import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { fetchData } from '../../Utils/Server';
import Endpoints from '../../Constants/Endpoints';
import PageLayout from '../Layout/PageLayout';
import { DataTable, Card, StatusBadge, Button } from '../UI';

const fmtKES = (cents) => `KES ${((cents || 0) / 100).toFixed(2)}`;

const columns = [
  { name: 'When', selector: 'created_at', cell: (row) => new Date(row.created_at).toLocaleString() },
  { name: 'Rider', selector: 'rider_id', cell: (row) => <code>{row.rider_id}</code> },
  { name: 'Principal', cell: (row) => fmtKES(row.principal_cents) },
  { name: 'Fee', cell: (row) => fmtKES(row.fee_cents) },
  { name: 'Repaid', cell: (row) => fmtKES(row.repaid_cents) },
  {
    name: 'Status',
    cell: (row) => <StatusBadge status={row.status}>{row.status}</StatusBadge>,
  },
  { name: '', right: true, cell: (row) => <Link to={`/loans/${row.id}`}><Button size="sm" variant="outline">Details</Button></Link> },
];

export default function LoansList() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchData(Endpoints.LIST_PENDING_LOANS)
      .then((r) => r.json())
      .then((res) => {
        setRows((res && res.data) || res || []);
        setLoading(false);
      });
  }, []);

  return (
    <PageLayout title="Pending fuel loans">
      <Card padded={false}>
        <DataTable
          columns={columns}
          data={rows}
          progressPending={loading}
          noHeader={true}
        />
      </Card>
    </PageLayout>
  );
}
